import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { getVessel } from "../../api/VesselDetails/addVesselApi";
import { getOrdersByVessel } from "../../api/order/orderApi";
import vessel1 from "../../assets/images/vessel1.jpg";
import "./OffCanvasPage.css";

export default function OffCanvasPage({
  isOpen1,
  vesselNumber,
  isOpenFunction,
}) {
  const [isOpen, setIsOpen] = useState(isOpen1); // Manage local state
  const [vesselData, setVesselData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [orderDetails, setOrderDetails] = useState(null);

  useEffect(() => {
    setIsOpen(isOpen1); // Sync with parent when prop changes
  }, [isOpen1]);

  useEffect(() => {
    if (isOpen) {
      fetchVesselData();
      fetchOrderData();
    }
  }, [isOpen]);

  const fetchVesselData = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await getVessel(vesselNumber);
      setVesselData(response.data);
    } catch (err) {
      setError("Failed to load vessel data.");
      console.error("Error fetching vessel data:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderData = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await getOrdersByVessel(vesselNumber);
      console.log("API Response:", response.data);

      setOrderDetails(response.data);
    } catch (err) {
      setError("Failed to load order data.");
      console.error("Error fetching order data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false); // Close sidebar using local state
    isOpenFunction();
  };

  return (
    <>
      {isOpen && <div className="overlay visible" onClick={handleClose}></div>}

      <div className={`offcanvas-sidebar ${isOpen ? "show" : ""}`}>
        <Row>
          <Col md={6} className="left-column">

            <img
              src={vessel1}
              alt="Vessel Image"
              style={{ width: "100%", borderRadius: "20px" }}
            />
            <h4 className="section-title mt-3">Profile View</h4>

            <img src={vessel1} alt="Vessel" className="vessel-image" style={{ width: "90%", padding: "auto", margin: "auto", alignSelf: "center", marginBottom: "5%" }} />
            <h5 className="section-title">Profile View</h5>


            {loading ? (
              <p>Loading vessel data...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : vesselData ? (
              <div className="profile-info">

                <p>
                  <strong>Name:</strong>{" "}
                  <span className="highlight">{vesselData.Name || "N/A"}</span>
                </p>
                <p>
                  <strong>Flag:</strong>{" "}
                  <span className="highlight">{vesselData.Flag || "N/A"}</span>
                </p>
                <p>
                  <strong>IMO:</strong>{" "}
                  <span className="highlight">{vesselData.IMO || "N/A"}</span>
                </p>
                <p>
                  <strong>IMULA Number:</strong>{" "}
                  <span className="highlight">
                    {vesselData.IMULA_Number || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Call Sign:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Call_Sign || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>AIS Transponder Class:</strong>{" "}
                  <span className="highlight">
                    {vesselData.AIS_Transponder_Class || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>General Vessel Type:</strong>{" "}
                  <span className="highlight">
                    {vesselData.General_Vessel_Type || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Detailed Vessel Type:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Detailed_Vessel_Type || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Categories:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Categories || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Service Status:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Service_Status || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Port of Registry:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Port_of_Registry || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Year Built:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Year_Built || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>License Category:</strong>{" "}
                  <span className="highlight">
                    {vesselData.License_Category || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Registered Date:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Registered_Date || "N/A"}
                  </span>
                </p>

              </div>
            ) : (
              <p>No vessel data found.</p>
            )}


            <h4 className="section-title" style={{ marginTop: "5%" }}>
              Past Orders
            </h4>
            {orderDetails ? (
              <Card style={{ marginTop: "4%" }}>

                <CardBody>
                  <img
                    src={vessel1}
                    style={{
                      width: "90px",
                      position: "absolute",
                      borderRadius: "10px",
                    }}
                  />
                  <div style={{ paddingLeft: "100px", position: "relative" }}>
                    {" "}
                    <p style={{ marginBottom: "0px" }}>
                      <strong>
                        {orderDetails.data.Product_Name || "No Product Name"}
                      </strong>
                    </p>
                    <p style={{ marginBottom: "0px" }}>
                      {orderDetails.data.Payment_Status ||
                        "No Status Available"}
                    </p>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <p>No past orders found.</p>
            )}
          </Col>
          

          <Col md={6} className="right-column">

            <h4 className="section-title mb-4">Vessel Characteristics</h4>

            <button className="close-btn" onClick={handleClose}>
              <X size={55} />
            </button>
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : vesselData ? (
              <div className="profile-info">
                <p>

                  <strong>Height:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Height || "N/A"}
                  </span>
                </p>
                <p>
                  <strong>Breadth:</strong>{" "}
                  <span className="highlight">
                    {vesselData.Breadth || "N/A"}
                  </span>

                </p>
                <p>
                  Fuel Type:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Engine Type:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Fuel Tank Capacity:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Hold Capacity:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Engine Capacity:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Fuel Consumption:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Fishing Method:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
                <p>
                  Hull Material:{" "}
                  <span className="highlight">
                    {vesselData.Engine_Capacity || "N/A"}
                  </span>
                </p>
              </div>
            ) : (
              <p>No vessel characteristics available.</p>
            )}


            <h4 className="section-title mt-4">Reviews</h4>

            <p className="font-medium">Bradley Lavior - ⭐4.5</p>
            <p className="text-gray-500 text-sm">
              "Experience the ocean's finest..."
            </p>

            <h4 className="section-title mt-4">Add a Review</h4>

  

            <input className="form-control mt-2" placeholder="Your Name" />
            <input className="form-control mt-2" placeholder="Email" />
            <textarea
              className="form-control mt-2"
              placeholder="Review"
            ></textarea>
            <Button className="w-100 mt-2 bg-black text-white">
              Submit Review
            </Button>

          
          </Col>
        </Row>
      </div>
    </>
  );
}
